"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const React = require("react");
function useFocusManagement({
  isOpen,
  closeOnBlurOutside = false,
  onBlurOutside,
  overlayRef,
  restoreFocusDelay = 0,
  shouldMount,
  shouldRestoreFocus = true
}) {
  const previouslyFocusedElementRef = React.useRef(null);
  const handleFocusTrap = React.useCallback(() => {
    var _a;
    const overlay = overlayRef.current;
    if (overlay) {
      const focusableElements = overlay.querySelectorAll(
        'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
      );
      (_a = focusableElements[0]) == null ? void 0 : _a.focus();
    }
  }, [overlayRef]);
  const restoreFocus = React.useCallback(() => {
    var _a;
    (_a = previouslyFocusedElementRef.current) == null ? void 0 : _a.focus();
  }, []);
  React.useEffect(() => {
    if (!isOpen || !onBlurOutside || !closeOnBlurOutside) return;
    const handleFocus = (event) => {
      const overlay = overlayRef.current;
      if (overlay && event.target instanceof Node && !overlay.contains(event.target)) {
        onBlurOutside();
      }
    };
    document.addEventListener("focusin", handleFocus);
    return () => {
      document.removeEventListener("focusin", handleFocus);
    };
  }, [isOpen, onBlurOutside, closeOnBlurOutside, overlayRef]);
  React.useEffect(() => {
    if (!shouldMount) return;
    if (isOpen) {
      if (shouldRestoreFocus) {
        previouslyFocusedElementRef.current = document.activeElement;
      }
      setTimeout(handleFocusTrap, 50);
    } else if (shouldRestoreFocus) {
      setTimeout(restoreFocus, restoreFocusDelay + 50);
    }
  }, [isOpen, handleFocusTrap, restoreFocus, restoreFocusDelay, shouldMount, shouldRestoreFocus]);
}
exports.useFocusManagement = useFocusManagement;
